// Articles authored by Ravi Teja Alchuri (trade and technical publications).
// `featured: true` is rendered larger and first.
export const writingData = [
    {
        id: 1,
        featured: true,
        title: 'Demystifying the Difference Between A2A (the Protocol) and Arazzo (the Specification)',
        description: 'A clear breakdown of how Google’s Agent-to-Agent (A2A) protocol and the Arazzo workflow specification differ, and how they fit together when designing interoperable, multi-agent AI systems.',
        date: 'May 18, 2026',
        topic: 'AI Agents & Interoperability',
        url: 'https://medium.com/towards-artificial-intelligence/demystifying-the-difference-between-a2a-the-protocol-and-arazzo-the-specification-83c11011da2b',
        source: 'Towards AI',
    },
    {
        id: 2,
        title: "Beyond Passive Recording: Why India's Commercial Fleets Are Ready for an AI Dash Cam Mandate",
        description: 'An invited analysis of how AI-powered dash cams can transform fleet safety and compliance across India’s commercial transportation sector.',
        date: 'Jan 2026',
        topic: 'Fleet Safety & AI',
        image: 'https://telematicswire.net/wp-content/uploads/2026/01/TW_Ravi_T_Alchuri_2-e1769529464313.jpg',
        url: 'https://telematicswire.net/beyond-passive-recording-why-indias-commercial-fleets-are-ready-for-an-ai-dash-cam-mandate/',
        source: 'Telematics Wire',
    },
    {
        id: 3,
        title: 'WeGuard: The Ultimate Mobile Device Management Solution for Your Business',
        description: 'How enterprise Mobile Device Management secures and orchestrates fleets of smartphones and tablets at scale.',
        date: 'Mar 2023',
        topic: 'MDM / Enterprise Mobility',
        image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*Z-Ytgj_3KiTQUGHTGsWDog.png',
        url: 'https://medium.com/@raviteja.alchuri/weguard-the-ultimate-mobile-device-management-solution-for-your-business-e5745cb48f8c',
        source: 'Medium',
    },
    {
        id: 4,
        title: 'Java Frameworks: Which One Should You Use for RESTful Web Services?',
        description: 'A practitioner’s comparison of the major Java frameworks for building production RESTful web services.',
        date: 'Mar 2023',
        topic: 'Backend Engineering',
        image: 'https://miro.medium.com/v2/resize:fit:4800/format:webp/1*g-g8hmZLj7_NF-2deDJFtA.jpeg',
        url: 'https://medium.com/@raviteja.alchuri/java-frameworks-which-one-should-you-use-for-restful-web-services-672c745fcec3',
        source: 'Medium',
    },
];
